<mat-label [class]="class" [style]="style" [matTooltip]="toolTip">
  <ng-content></ng-content><span *ngIf="required" class="color-warn"> *</span>
</mat-label>
